import MinusIcon from "@components/icons/minus-icon";
import PlusIcon from "@components/icons/plus-icon";
import cn from "classnames";
type CounterProps = {
  quantity: number;
  onDecrement: (e: any) => void;
  onIncrement: (e: any) => void;
  disableIncrement?: boolean;
  disableDecrement?: boolean;
  variant?: "default" | "rounded" | "dark" | "light";
  className?: string;
};
const Counter: React.FC<CounterProps> = ({
  quantity,
  onDecrement,
  onIncrement,
  disableIncrement = false,
  disableDecrement = false,
  variant = "default"
}) => {
  const size = variant === "dark" ? "10px" : "12px";
  return <div className={cn("group flex items-center justify-between overflow-hidden flex-shrink-0", {
    "rounded-md": variant === "default" || variant === "dark" || variant === "light",
    "rounded-3xl": variant === "rounded",
    "backdrop-blur": variant === "rounded"
  }, {
    "border h-11 md:h-12 border-gray-300 dark:border-neutral-600": variant === "default",
    "border h-8 md:h-9 border-gray-300 dark:border-neutral-600": variant === "rounded",
    "ml-auto": variant === "rounded",
    "h-8 md:h-9 shadow-navigation bg-heading dark:bg-neutral-600": variant === "dark",
    "h-10 md:h-11 shadow-navigation bg-neutral-400 dark:bg-neutral-600 text-neutral-100": variant === "light"
  })} data-sentry-component="Counter" data-sentry-source-file="counter.tsx">
			<button onClick={onDecrement} className={cn("flex items-center justify-center flex-shrink-0 h-full transition ease-in-out duration-300 focus:outline-none", {
      "w-10 md:w-12 text-heading dark:text-neutral-200 border-e border-gray-300 dark:border-e-neutral-600 hover:text-white hover:bg-heading": variant === "default"
    }, {
      "w-7 md:w-8 text-heading dark:text-neutral-200 border-e border-gray-300 dark:border-e-neutral-600 hover:text-white hover:bg-heading": variant === "rounded"
    }, {
      "w-8 md:w-9 text-white bg-heading dark:bg-neutral-600 hover:bg-gray-600 focus:outline-none": variant === "dark",
      "w-10 md:w-11 text-neutral-100 dark:text-neutral-200 bg-neutral-400 dark:bg-neutral-600 hover:bg-neutral-500": variant === "light"
    })} disabled={disableDecrement}>
				<MinusIcon width={size} data-sentry-element="MinusIcon" data-sentry-source-file="counter.tsx" />
			</button>

			<span className={cn("font-semibold flex items-center justify-center h-full transition-colors duration-250 ease-in-out cursor-default flex-shrink-0", {
      "text-base text-heading dark:text-neutral-200 w-12 md:w-20 xl:w-24": variant === "default"
    }, {
      "text-base text-heading dark:text-neutral-200 w-8 md:w-12 xl:w-16": variant === "rounded"
    }, {
      "text-sm text-white w-8 md:w-10": variant === "dark",
      "text-base text-neutral-100 w-10 md:w-12": variant === "light"
    })}>
				{quantity}
			</span>

			<button onClick={onIncrement} className={cn("flex items-center justify-center h-full flex-shrink-0 transition ease-in-out duration-300 focus:outline-none", {
      "w-10 md:w-12 text-heading dark:text-neutral-200 border-s border-gray-300 dark:border-s-neutral-600 hover:text-white hover:bg-heading": variant === "default"
    }, {
      "w-7 md:w-8 text-heading dark:text-neutral-200 border-s border-gray-300 dark:border-s-neutral-600 hover:text-white hover:bg-heading": variant === "rounded"
    }, {
      "w-8 md:w-9 text-white dark:text-neutral-200 bg-heading dark:bg-neutral-600 hover:bg-gray-600 focus:outline-none": variant === "dark",
      "w-10 md:w-11 text-neutral-100 dark:text-neutral-200 bg-neutral-400 dark:bg-neutral-600 hover:bg-neutral-500": variant === "light"
    })} disabled={disableIncrement}>
				<PlusIcon width={size} height={size} data-sentry-element="PlusIcon" data-sentry-source-file="counter.tsx" />
			</button>
		</div>;
};
export default Counter;